import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMeinSchiff6 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#mein-schiff-6_svg__a)">
      <path
        fill="#263E6A"
        d="M11.947 13.589c-.241 0-.538.15-.732.396.024-.931.371-1.25.794-1.25.204 0 .414.108.54.255l.329-.372a1.22 1.22 0 0 0-.903-.383c-.693 0-1.328.546-1.328 1.857 0 1.137.563 1.651 1.224 1.651.578 0 1.062-.433 1.062-1.109 0-.705-.404-1.045-.986-1.045m-.085 1.687c-.328 0-.57-.256-.633-.852.189-.284.415-.393.606-.393.335 0 .533.205.533.603 0 .413-.225.642-.506.642m6.634 3.125c-.933 0-1.653-.096-2.236-.246l1.66-4.439a.61.61 0 0 0-.019-.475.61.61 0 0 0-.35-.322l-.678-.247v-3.05h.68c.131 0 .237-.106.237-.236v-1.12a.236.236 0 0 0-.236-.237h-1.375V6.51a.365.365 0 0 0-.365-.365h-2.647V5.117c0-.2-.163-.362-.362-.362h-1.772c-.2 0-.362.163-.362.362v1.028H7.515a.365.365 0 0 0-.365.365v1.519H5.748a.236.236 0 0 0-.236.236v1.12c0 .131.106.237.236.237h.93V12.7l-.68.24a.612.612 0 0 0-.372.795l1.617 4.35c-.62.19-1.354.316-2.275.316a.236.236 0 0 0 0 .473c2.186 0 3.375-.668 4.424-1.257.776-.435 1.446-.812 2.388-.812.982 0 1.506.343 2.17.776.882.576 1.98 1.292 4.546 1.292a.236.236 0 0 0 0-.472M11.143 5.227h1.551v.918h-1.55zm-3.52 1.39h8.084V8.03H7.622zM5.983 9.15V8.5h11.334v.649H5.984m10.417.472V12.5l-4.073-1.48a1.5 1.5 0 0 0-.886-.004L7.15 12.533V9.622zm-2.193 7.564c-.672-.439-1.306-.853-2.428-.853-1.065 0-1.82.424-2.62.873-.44.247-.908.51-1.47.725l-1.621-4.36a.143.143 0 0 1 .086-.185l5.444-1.924a1.03 1.03 0 0 1 .568.002l5.223 1.898q.056.02.083.076a.15.15 0 0 1 .004.113l-1.67 4.468c-.68-.234-1.155-.543-1.6-.833"
      />
    </g>
    <defs>
      <clipPath id="mein-schiff-6_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMeinSchiff6;
